import React from 'react'
import styled from 'styled-components'
import { Text } from '@olxbr/design-system'

const Title = styled(Text)`
  color: #4a4a4a;
  font-size: 20px;
  text-align: center;
  font-weight: 600;
`
export default Title
